/**
 * Legacy (global) stylesheets can sometimes have impacts outside of their intended
 * import area, which can cause styling regressions when code-splitting, due to
 * either missing or mis-ordered styles.
 *
 * To make sure stylesheets always load -- and always load in the right order --
 * move them into this file, which is always imported immediately at app load.
 */

import '@wandb/weave/css/wandbTailwindPreflight.css';
import './index.css';
import '@wandb/weave/common/assets/careyfont/css/careyfont-embedded.css';
import '@wandb/weave/common/assets/wb-icons/wb-icons.css';
import '@wandb/weave/common/components/elements/Toast.css';
import '@wandb/weave/common/components/JupyterViewer.css';
import '@wandb/weave/common/components/Tags/Tags.less';
import '@wandb/weave/common/css/Base.less';
import '@wandb/weave/common/css/DragDrop.less';
import '@wandb/weave/common/css/EditableField.less';
import '@wandb/weave/common/css/Markdown.less';
import '@wandb/weave/common/css/NumberInput.less';
import '@wandb/weave/common/index.css';
import '@wandb/semantic/semantic.min.css';
import '@wandb/weave/components/Panel2/PanelTable/baseTable.css';
import '@wandb/weave/css/ControlBox.less';
import 'katex/dist/katex.css';
import 'react-base-table/styles.css';
import 'react-resizable/css/styles.css';
import 'react-table/react-table.css';
import 'react-toastify/dist/ReactToastify.css';
import '@xyflow/react/dist/style.css';
import '../node_modules/react-vis/dist/style.css';
import './css/vars/boxShadowTailwind.less';
import './components/common/PopoverTextOverflow/PopoverTextOverflow.less';
import './components/common/TruncateText/TruncateText.less';
import './components/AnnotateScreenshot.less';
import './components/ArtifactSidebar/ArtifactsSidebar.less';
import './components/Axis.less';
import './components/PanelTitle/PanelTitle.less';
import './components/Project/ProjectRenameModal.less';
import './components/PublishedWorkTable.less';
import './components/Reports/CreateReportPrompt/CreateReportPrompt.less';
import './components/RunMover.less';
import './components/SearchableJSONTree/SearchableJSONTree.less';
import './components/Slate/plugins/markdown-blocks.less';
import './components/vis/CanvasWrapper.css';
import './components/vis/ReactVis.css';
import './components/RunSelector/WBTable/WBTable.less';
import './css/TailwindComponents/TailwindSegment.less';
import './css/ActionTable.less';
import './css/ActivityCalendar.less';
import './css/AddVisMenu.less';
import './css/Alerts.less';
import './css/ArtifactLabels.less';
import './css/Artifacts.less';
import './css/AuthorizePage.less';
import './css/BarChart.less';
import './css/BillingPage.less';
import './css/BottomPanel.less';
import './css/Breadcrumbs.less';
import './css/CloneReportModal.less';
import './css/Code.less';
import './css/Components.less';
import './css/CopyableText.less';
import './css/CreateReportModal.less';
import './css/CreateSweepPage.less';
import './css/DiscussionBoard.less';
import './css/EditableImage.less';
import './css/EditableLabel.less';
import './css/EditablePanel.less';
import './css/EditLaunchConfigModal.less';
import './css/EmptyWatermark.less';
import './css/ErrorPage.less';
import './css/ErrorPortal.less';
import './css/ExpandableProjectList.less';
import './css/FancyPage.less';
import './css/flash.less';
import './css/GradientPicker.less';
import './css/GroupPage.less';
import './css/HelpPopup.less';
import './css/HighlightedIcon.less';
import './css/Home.less';
import './css/ImageIconHeader.less';
import './css/ImagePreview.less';
import './css/InlineMarkdownEditor.less';
import './css/LinePlot.less';
import './css/LineStylePicker.less';
import './css/LinkButton.less';
import './css/MemberInfo.less';
import './css/MetricsPicker.less';
import './css/MiniPagination.less';
import './css/ModifiedDropdown.less';
import './css/NavBar.less';
import './css/NewUserFooter.less';
import './css/NoMatch.less';
import './css/OnboardingFlow.less';
import './css/PanelBank.less';
import './css/PanelBankFlowSection.less';
import './css/PanelBankGridSection.less';
import './css/PanelCodeComparer.less';
import './css/PanelConfig.less';
import './css/PanelGroupingOptions.less';
import './css/PanelMediaBrowser.less';
import './css/PanelMultiRunTable.less';
import './css/PanelParallelCoord.less';
import './css/PanelParameterImportance.less';
import './css/PanelRunComparerNew.less';
import './css/PanelRunsLinePlot.less';
import './css/PanelScatterPlot.less';
import './css/PanelSettings.less';
import './css/PlotWarning.less';
import './css/PopupDropdown.less';
import './css/ProfileSidebar.less';
import './css/ProjectCard.less';
import './css/ProjectFieldSelector.less';
import './css/ProjectList.less';
import './css/ProjectOverview.less';
import './css/ProjectPageOnboarding.less';
import './css/RangeInput.less';
import './css/ReportPage.less';
import './css/ReportPageHeaderEdit.less';
import './css/ReportPageHeaderView.less';
import './css/ReportShowcase.less';
import './css/ReportsTable.less';
import './css/ReportTable.less';
import './css/RoutedTab.less';
import './css/RunOverview.less';
import './css/RunPage.less';
import './css/RunSelector.less';
import './css/ScalarChart.less';
import './css/SearchModal.less';
import './css/SearchNav.less';
import './css/SettingsPage.less';
import './css/ShareReportPopup.less';
import './css/SlackIntegration.less';
import './css/SliderInput.less';
import './css/SmoothingInput.less';
import './css/StargazerModal.less';
import './css/SubscribeForm.less';
import './css/SweepPage.less';
import './css/SweepsTable.less';
import './css/TableCard.less';
import './css/TableEditor.less';
import './css/TagAddButton.less';
import './css/Tags.less';
import './css/Text.less';
import './css/Views/ViewBar.less';
import './css/Views/ViewMenu.less';
import './css/WBLogo.less';
import './css/WBReactTable.less';
import './css/WBReactFlow.less';
import './pages/Profile.css';
import './css/_overrides.css';
